import gql from 'graphql-tag'

export const planFragment = gql`
  fragment planAttrs on Plan {
    __typename
    id
    name
    isFree
    amount
    monthlyPricePerUser
    displayOrder
    discountPercentage
    interval
    altIntervalId
    product
  }
`

export const subscriptionFragment = gql`
  fragment subscriptionAttrs on PlanSubscription {
    __typename
    id
    createdById
    createdAt
    currentPeriodEnd
    canceledAt
    trialEndAt
  }
`

export const paymentInfosFragment = gql`
  fragment paymentInfosAttrs on PaymentInfos {
    __typename
    id
    last4
    credit
    vatId
    cardExpMonth
    cardExpYear
    cardBrand
    billingEmail
    addressName
    addressLine1
    addressLine2
    addressCity
    addressPostalCode
    addressState
    addressCountry
    coupon {
      __typename
      id
      name
    }
    plan {
      ...planAttrs
    }
    subscription {
      ...subscriptionAttrs
    }
  }
  ${planFragment}
  ${subscriptionFragment}
`
